import paymentMethods from "@/helpers/paymentMethods";
import orderStatuses from "@/helpers/orderStatuses";

export default function () {
    return {
        order: {},
        showUpdateStatus: false,
        newStatus: null,
        currentAlertSuccessCounter: 0,
        currentAlertDangerCounter: 0,
        commentSuccess: null,
        refundModalVisible: false,
        availableStatus: [
            {
                label: 'Processando',
                value: 1
            },
            {
                label: 'Autorizado',
                value: 2
            },
            {
                label: 'Pago',
                value: 3
            },
            {
                label: 'Reembolsado',
                value: 4
            },
            {
                label: 'Aguardando pagamento',
                value: 5
            },
            {
                label: 'Reembolso pendente',
                value: 6
            },
            {
                label: 'Negado',
                value: 7
            },
            {
                label: 'Cancelado',
                value: 8
            },
            {
                label: 'Não pago',
                value: 9
            },
            {
                label: 'Verificar nome',
                value: 10
            },
            {
                label: 'Aguardando pagamento pix',
                value: 11
            }
        ],
        paymentMethods,
        orderStatuses
    }
}
